import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import logo from '../../assets/logo/FPHC_Logo_RGB_150118_klein_Deckblatt.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  const links = [
    { path: '/', label: 'Startseite' },
    { path: '/services', label: 'Leistungen' },
    { path: '/about', label: 'Über uns' },
    { path: '/contact', label: 'Kontakt' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className="fixed top-0 w-full px-2 sm:px-4 py-2 z-50 transition-all duration-300">
      <nav className={`container mx-auto bg-white/80 backdrop-blur-md rounded-2xl px-4 sm:px-6 py-4 flex items-center justify-between transition-all duration-300 ${
        isScrolled ? 'shadow-lg' : ''
      }`}>
        <Link to="/" className="flex items-center space-x-2">
          <img 
            src={logo}
            alt="FPHC Logo" 
            className="h-8 sm:h-12 w-auto"
          />
        </Link>
        
        <div className="hidden lg:flex items-center space-x-8">
          {links.map(({ path, label }) => (
            <Link
              key={path}
              to={path}
              className={`${
                location.pathname === path
                  ? 'text-success font-medium'
                  : 'text-gray-600 hover:text-success'
              } transition-colors`}
            >
              {label}
            </Link>
          ))}
          <a 
            href="tel:+436644704858" 
            className="hidden xl:flex items-center space-x-2 text-success hover:text-dark transition-colors"
          >
            <Phone className="h-5 w-5" />
            <span>+43 664 470 48 58</span>
          </a>
        </div>
        
        <Link
          to="/contact"
          className="hidden lg:block bg-success hover:bg-dark text-white px-6 py-2.5 rounded-xl transition-colors"
        >
          Angebot anfordern
        </Link>

        <button
          className="lg:hidden text-gray-600 p-2 transition-transform duration-200 ease-in-out hover:scale-105"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>

        <div 
          className={`absolute top-full left-2 right-2 mt-2 bg-white rounded-xl shadow-lg transform transition-all duration-200 ease-in-out origin-top lg:hidden ${
            isMenuOpen 
              ? 'opacity-100 translate-y-0 scale-100' 
              : 'opacity-0 -translate-y-4 scale-95 pointer-events-none'
          }`}
        >
          <div className="p-4 space-y-3">
            {links.map(({ path, label }) => (
              <Link
                key={path}
                to={path}
                className={`block py-2 px-4 rounded-lg transform transition-all duration-200 ease-in-out ${
                  location.pathname === path
                    ? 'text-success font-medium bg-success/5 translate-x-1'
                    : 'text-gray-600 hover:bg-gray-50 hover:translate-x-1'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                {label}
              </Link>
            ))}
            <a 
              href="tel:+436644704858"
              className="flex items-center space-x-2 py-2 px-4 text-success rounded-lg hover:bg-success/5 transform transition-all duration-200 ease-in-out hover:translate-x-1"
              onClick={() => setIsMenuOpen(false)}
            >
              <Phone className="h-5 w-5" />
              <span>+43 664 470 48 58</span>
            </a>
            <Link
              to="/contact"
              className="block mt-2 bg-success text-white py-3 px-4 rounded-lg text-center hover:bg-dark transition-all duration-200 ease-in-out transform hover:translate-x-1 hover:shadow-md"
              onClick={() => setIsMenuOpen(false)}
            >
              Angebot anfordern
            </Link>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;